module.exports = __webpack_public_path__ + "img/stephan-schambach.19b20934.png";